// Runtime configuration, resolved once at module load.
//
// window.__ENV__ is written by docker-entrypoint.sh at container start from the
// k8s deployment env, so the same image serves every environment. process.env is
// the Parcel build-time fallback (baked in via the Dockerfile ARG) for local dev.

const runtime = (typeof window !== 'undefined' && window.__ENV__) || {};

// The GraphQL endpoint of parsina.bff.student (:4006), read by src/lib/bffClient.js.
//
// The BFF mounts Apollo at `/`, and express's `app.use('/')` is a catch-all, so
// the `/graphql` suffix is accepted as well as the bare origin. The suffix is
// kept because every sibling client spells its BFF_URL that way — one shape for
// the variable is worth more than a byte saved.
//
// The default below is the STAGING host (staging = sapi.parsinabot.ir, beta1 =
// beta1.sapi.parsinabot.ir). The deployment is expected to set BFF_URL per
// environment; a beta1 pod silently reading staging's data would be far worse
// than one that fails visibly.
export const BFF_URL =
  runtime.BFF_URL || process.env.BFF_URL || 'https://sapi.parsinabot.ir/graphql';

// Keycloak origin, no realm path — auth.js appends /realms/<realm>. Routed
// through here (rather than a bare constant in auth.js) so the deployment can
// move the SSO host without a client rebuild, same as the sibling clients.
//
// The CLIENT ID is deliberately NOT here: Parcel inlines `process.env.*` into
// the bundle at build time, so it cannot be swapped at runtime through
// window.__ENV__, and pretending otherwise would produce a variable that looks
// configurable and silently is not. It lives in auth.js, set by the Dockerfile.
export const KC_BASE_URL =
  runtime.PARSINA_KC_BASE_URL ||
  process.env.PARSINA_KC_BASE_URL ||
  'https://sso.itechtrade.ir';

// Origin of حساب پارسینا — where a person edits their own identity, password,
// language and two-factor, for every panel at once. Supplied per environment by
// the deployment, exactly like BFF_URL, rather than baked into the image: a
// beta1 panel linking to the staging account app would hand someone a session
// against another environment's data.
//
// Like the clinic switch, this is a plain navigation and not a token hand-off —
// same realm, so the account app runs its own PKCE flow and Keycloak's SSO
// session returns a token without a second sign-in.
//
// No trailing slash — callers append the path.
export const ACCOUNT_APP_URL = (
  runtime.ACCOUNT_APP_URL ||
  process.env.ACCOUNT_APP_URL ||
  'https://account.parsinabot.ir'
).replace(/\/+$/, '');

/**
 * A link into the account app that can find its way back here.
 *
 * `return_url` is checked SERVER-SIDE by the account app against its own
 * allowlist; this origin is already on it for both environments. An unlisted
 * host does not error — the «بازگشت» chip simply does not render — so a new
 * panel hostname needs adding there before its link is useful.
 */
export function accountUrl(section = '/') {
  const back = typeof window !== 'undefined' ? window.location.origin : '';
  const path = section.startsWith('/') ? section : `/${section}`;
  return `${ACCOUNT_APP_URL}${path}${back ? `?return_url=${encodeURIComponent(back)}` : ''}`;
}
